function t(n) {
  var r = [];
  if (n != null)
    for (var e in Object(n))
      r.push(e);
  return r;
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_nativeKeysIn.js
// module id = 1497
// module chunks = 41